<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6">
        <j-select
          v-if="$vuetify.breakpoint.xsOnly"
          :items="
            getStoresAvailables.filter(
              x => x.organisation === getOrganisationId
            )
          "
          v-model="store"
          item-key="id_store"
          item-text="name_store"
          label="Quantités requises pour la succursale"
          prepend-icon="home"
          close-on-select
        ></j-select>
        <v-select
          v-else
          label="Quantités requises pour la succursale"
          v-model="store"
          :items="
            getStoresAvailables.filter(
              x => x.organisation === getOrganisationId
            )
          "
          item-value="id_store"
          item-text="name_store"
          prepend-icon="home"
        ></v-select>
      </v-col>
    </v-row>
    <OrderTemplateGrid
      v-if="templates && !loading"
      :templates="templates"
      :orderQuantities="orderQuantities.filter(x => x.store === store)"
      :store="store"
      :product="product"
      @update="v => updateQuantities(v)"
    ></OrderTemplateGrid>
    <v-row v-else-if="loading" align="center" justify="center">
      <v-progress-circular
        color="primary"
        indeterminate
        class="my-3"
      ></v-progress-circular>
    </v-row>
    <v-row align="center" justify="space-between" no-gutters>
      <v-btn
        @click="addTemplate"
        :block="$vuetify.breakpoint.xsOnly"
        :large="$vuetify.breakpoint.smAndDown"
        class="my-1"
      >
        <v-icon left small>fa-plus</v-icon>Ajouter un gabarit
      </v-btn>
      <OrderTemplateEditor @update="getTemplates"></OrderTemplateEditor>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/api";
import OrderTemplateGrid from "./OrderTemplateGrid";
import OrderTemplateEditor from "./OrderTemplateEditor";
export default {
  name: "OrderTemplateInput",
  components: {
    OrderTemplateGrid,
    OrderTemplateEditor
  },
  props: {
    product: {
      required: true
    },
    orderQuantities: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getStoreId", "getOrganisationId", "getStoresAvailables"])
  },
  mounted() {
    this.getTemplates();
    this.store = this.getStoreId;
  },
  data() {
    return {
      loading: true,
      store: this.getStoreId,
      templates: undefined
    };
  },
  methods: {
    async getTemplates() {
      try {
        this.loading = true;
        const res = await api.getOrderTemplates();
        this.templates = res.filter(
          x => x.organisation === this.getOrganisationId
        );
      } finally {
        this.loading = false;
      }
    },
    async addTemplate() {
      let templateName = await this.$dialog.prompt({
        text: "Entrer le nom du nouveau gabarit",
        title: "Nouveau gabarit"
      });
      if (templateName) {
        const data = {
          organisation: this.getOrganisationId,
          name: templateName
        };
        try {
          this.$store.dispatch("startLoadingOverlay");
          const res = await api.postOrderTemplate(data);
          this.templates.push(res);
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    },
    updateQuantities(value) {
      if (!value.id || value.id === null || value.id === "") {
        const existing = this.orderQuantities.find(
          x =>
            x.store === value.store &&
            x.fk_order_template === value.fk_order_template
        );
        if (existing) {
          existing.quantity = value.quantity;
        } else {
          this.$emit("update:orderQuantities", [
            ...this.orderQuantities,
            value
          ]);
        }
      }
    },
    async save() {
      const tasks = [];
      this.orderQuantities.forEach(x => {
        if (x.id && x.id !== null) {
          tasks.push(api.putRecipeProductOrderQuantity(x.id, x));
        } else {
          const data = {
            ...x,
            fk_product: this.product.id
          };
          tasks.push(api.postRecipeProductOrderQuantity(data));
        }
      });
      await Promise.all(tasks);
    }
  }
};
</script>

<style lang="scss" scoped></style>
